import $ from 'jquery';
import { InventorySearchEvents } from '@dealersites/inventory/events';

import { LocalGarage } from './local';
import { syncGlobalGarageIcon } from './utils';

$(document).on(InventorySearchEvents.GARAGE_UPDATED, syncGlobalGarageIcon);

const $garageCover = $('#garage-cover');
if ($garageCover.length) {
  $(document).on(InventorySearchEvents.GARAGE_ITEM_ADD, () => {
    $garageCover.removeClass('hidden');
  });

  $(document).on(InventorySearchEvents.GARAGE_ITEM_ADDED, () => {
    $garageCover.removeClass('hidden');
  });

  $(document).on(InventorySearchEvents.GARAGE_ITEM_REMOVE, () => {
    $garageCover.removeClass('hidden');
  });

  $(document).on(InventorySearchEvents.GARAGE_ITEM_REMOVED, () => {
    location.reload();
    setTimeout(() => {
      $garageCover.addClass('hidden');
    }, 2000);
  });

  $(document).on(InventorySearchEvents.GARAGE_ITEM_CLEAR, () => {
    $garageCover.removeClass('hidden');
  });

  $(document).on(InventorySearchEvents.GARAGE_ITEM_CLEARED, () => {
    location.reload();
    setTimeout(() => {
      $garageCover.addClass('hidden');
    }, 2000);
  });
}

$(document).on('InventorySearchEvents.POST_RENDER', () => {
  LocalGarage.init();
});

LocalGarage.init();
